import { render, staticRenderFns } from "./ReviewWelcome.vue?vue&type=template&id=4a6d26be&scoped=true&"
import script from "./ReviewWelcome.vue?vue&type=script&lang=js&"
export * from "./ReviewWelcome.vue?vue&type=script&lang=js&"
import style0 from "./ReviewWelcome.vue?vue&type=style&index=0&id=4a6d26be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d26be",
  null
  
)

export default component.exports